const ACTION_GET_COMPARE_USAGE_DATA = 'ACTION_GET_COMPARE_USAGE_DATA'
const ACTION_GET_COMPARE_USAGE_DATA_SUCCESS = 'ACTION_GET_COMPARE_USAGE_DATA_SUCCESS'

export { ACTION_GET_COMPARE_USAGE_DATA, ACTION_GET_COMPARE_USAGE_DATA_SUCCESS }
